export default __webpack_public_path__ + "static/media/logoImage.33fa0934.png";